import React from 'react';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center bg-[#1a1a1a] text-[#fafafa] px-4 pt-20 overflow-hidden" data-id="element-47">
      <div className="max-w-5xl mx-auto text-center z-10" data-id="element-48">
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-light tracking-tight leading-[1.1] mb-8" data-id="element-49">
          The global marketplace connecting{' '}
          <span className="font-semibold text-[#b8d4e8]" data-id="element-50">online retailers</span>{' '}
          with{' '}
          <span className="font-semibold text-[#b8d4e8]" data-id="element-51">manufacturers</span>.
        </h1>

        <p className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto mb-12 font-light" data-id="element-52">
          Increase your sales and profits by finding under-supplied markets. Pimlico Trading accurately models demand for your products, and finds retailers to sell them in under-served, high-demand online channels.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-53">
          <a href="#use-cases" className="inline-flex items-center justify-center rounded-full transition-all duration-300 font-medium tracking-wide focus:outline-none focus:ring-2 focus:ring-offset-2 bg-[#1e3a5f] text-white hover:bg-[#152a45] focus:ring-[#1e3a5f] border border-transparent px-8 py-4 text-sm uppercase" data-id="element-54">
            How It Works
            <ArrowRight className="ml-2 h-4 w-4" data-id="element-55" />
          </a>
        </div>
      </div>

      {/* Abstract Background Element */}
      <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-[#1a1a1a] via-[#1a1a1a]/50 to-transparent pointer-events-none" data-id="element-56" />
    </section>;
}